import script from "./BackButton.vue?vue&type=script&setup=true&lang=js"
export * from "./BackButton.vue?vue&type=script&setup=true&lang=js"

import "./BackButton.vue?vue&type=style&index=0&id=667a6346&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-667a6346"]])

export default __exports__